import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const LATEX = { alpha: "α", beta: "β", gamma: "γ", delta: "δ", Delta: "Δ", theta: "θ", lambda: "λ", mu: "μ", pi: "π", rho: "ρ",
  sigma: "σ", omega: "ω", Omega: "Ω", phi: "φ", epsilon: "ε", times: "×", cdot: "·", div: "÷", pm: "±", approx: "≈", neq: "≠",
  leq: "≤", geq: "≥", rightarrow: "→", to: "→", leftarrow: "←", Rightarrow: "⇒", infty: "∞", circ: "°", sqrt: "√", propto: "∝" };
const SUP = { 0: "⁰", 1: "¹", 2: "²", 3: "³", 4: "⁴", 5: "⁵", 6: "⁶", 7: "⁷", 8: "⁸", 9: "⁹", "+": "⁺", "-": "⁻", n: "ⁿ" };
const SUB = { 0: "₀", 1: "₁", 2: "₂", 3: "₃", 4: "₄", 5: "₅", 6: "₆", 7: "₇", 8: "₈", 9: "₉" };

// Cleans leftover LaTeX / stray symbols in older notes at display time (no regeneration needed).
export const cleanText = (t = "") => t
  .replace(/\$\$([\s\S]+?)\$\$/g, "`$1`").replace(/\$([^$\n]+?)\$/g, "`$1`")
  .replace(/\\[()[\]]/g, "")
  .replace(/\\frac\{([^{}]*)\}\{([^{}]*)\}/g, "($1)/($2)")
  .replace(/\\sqrt\{([^{}]*)\}/g, "√($1)")
  .replace(/\\(?:text|mathrm|mathbf|vec)\{([^{}]*)\}/g, "$1")
  .replace(/\\([A-Za-z]+)/g, (m, w) => LATEX[w] ?? w)
  .replace(/\^\{?([0-9+\-n]{1,3})\}?/g, (m, d) => [...d].map((c) => SUP[c] ?? c).join(""))
  .replace(/_\{([0-9]{1,2})\}/g, (m, d) => [...d].map((c) => SUB[c]).join(""))
  .replace(/\$/g, "")
  .replace(/^\s*#{4,}\s*/gm, "### ")
  .replace(/[\u25A1\uFFFD\u200B]/g, "");

export default function Markdown({ children }) {
  return (
    <div className="md-body">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{cleanText(children || "")}</ReactMarkdown>
    </div>
  );
}
